import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!token) return toast.error("Missing token");
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset! You can now log in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-12" data-testid="reset-page">
      <form
        onSubmit={onSubmit}
        className="w-full max-w-md bg-white rounded-3xl p-8 shadow-sm border border-black/5"
        data-testid="reset-form"
      >
        <h1 className="font-display text-3xl font-bold uppercase" style={{ color: "#13A699" }}>Reset Password</h1>
        <label className="block mt-5 text-sm font-semibold" style={{ color: "#13A699" }}>New Password</label>
        <input
          required
          type="password"
          minLength={6}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 w-full rounded-xl border border-black/10 px-4 py-3 outline-none focus:ring-2 focus:ring-[#13A699] bg-white text-[#13A699]"
          data-testid="reset-password-input"
        />
        <button
          type="submit"
          disabled={submitting}
          className="btn-yellow w-full mt-6 py-3 disabled:opacity-60"
          data-testid="reset-submit-btn"
        >
          {submitting ? "Resetting..." : "Reset Password"}
        </button>
        <div className="mt-4 text-sm text-center" style={{ color: "#13A699" }}>
          <Link to="/login" className="font-bold">Back to Login</Link>
        </div>
      </form>
    </div>
  );
}
